// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
__webpack_require__("./node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/stable/index.js");
var __webpack_exports__ = __webpack_require__("./node_modules/.pnpm/regenerator-runtime@0.13.11/node_modules/regenerator-runtime/runtime.js");
